import { render } from "./RatingBarRank2.vue?vue&type=template&id=2f7cea63&scoped=true"
const script = {}

import "./RatingBarRank2.vue?vue&type=style&index=0&id=2f7cea63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7cea63"]])

export default __exports__